export { CpfPipe } from './cpf.pipe';
export { CnpjPipe } from './cnpj.pipe';
export { TelefonePipe } from './telefone.pipe';
export { ExtendDatePipe } from './extenddate.pipe';